export default "__VITE_ASSET__DVu83ekD__"